// © 2015-2021 WDNA - All Rights Reserved

import { SmartConfig } from 'wdna-components/lib/layout/types';
import { COMMON_CONFIG, COMMON_SKINS } from './general';

const urlAPI: string = '/sensorpatrol/api';
const urlFBD: string = '/freeboard';
const urlMAP: string = 'https://live.sensorpatrol.com/mapserver/style.php?name=dark&map=spain';

const SmartAdminConfig: SmartConfig = {
  ...COMMON_CONFIG,

  apiRootUrl: `${urlAPI}`,
  fbdRootUrl: `${urlFBD}`,
  mapRootUrl: `${urlMAP}`,

  skins: COMMON_SKINS,
};

export const config: SmartConfig = SmartAdminConfig;
